import React, { useState, useEffect } from 'react'
import { Button, TextField } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';

export default function SendOffer(props) {
    const [openSubmit, setOpenSubmit] = React.useState(false);
    const [lastEmailError, setLastEmailError] = useState(false)
    const handleClickOpen = () => {
        setOpenSubmit(!openSubmit);
        props.setIsFinishBtn(false);
    };
    const handleEmailEdit = (event, props) => {
        props && props.setEmailEdit(true);
        try {
            props.setEmailEditErr(true);
        } catch (error) {
        }
    }
    const handleChange = (e) => {
        props.values.customer_info.customer_email_last = e.target.value;
        props.setEmailValue(props.values.customer_info.customer_email_last);
        props.values.customer_info.customer_email = e.target.value
        try {
            props.setEmailEditErr(true);
        } catch (error) {
        }
    }

    useEffect(() => {
        props.values.customer_info.customer_email_last = props.values.customer_info.customer_email
    }, [props.values.customer_info.customer_email_last, props.values.customer_info.customer_email])

    useEffect(() => {
        if (props.values.customer_info.customer_email_last) {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(props.values.customer_info.customer_email_last)) {
                setLastEmailError(true)
                let lastemail = document.getElementById('submit');
                lastemail.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            } else {
                setLastEmailError(false)
            }
        } else if (props.emailValue) {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(props.emailValue)) {
                setLastEmailError(true)
                let lastemail = document.getElementById('submit');
                lastemail.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            } else {
                setLastEmailError(false)
            }
        } else if (props.emailValue === '') {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(props.emailValue)) {
                setLastEmailError(true)
                let lastemail = document.getElementById('submit');
                lastemail.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            } else {
                setLastEmailError(false)
            }
        }
    })

    const handleKeyDown = e => {
		if (e.key === " ") {
		  e.preventDefault();
		}
	  };

    const pageHandler = ()=>{
        props.handlePageChange(2)
        if(props.values.property_defect_id.length > 0){
            props.setIsDefects(true);
        }
    }

    return (
        <div className="form-question" style={{ display: 'flex', alignItems: 'top', minHeight: '66vh' }}>
            <div className="form-content" >
                <h4 className="form-content-heading m-0" style={{ wordWrap: 'break-word' }}>Thank you for your time. Can we confirm we’re sending the offer to {props.emailValue ? props.emailValue : props.values.customer_info.customer_email}?</h4>
                <p style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-light"}:{}}>To update your email address, <span style={{ textDecoration: 'underline', color: 'blue', fontWeight: 'bold', cursor: 'pointer' }} onClick={(e) => handleEmailEdit(e, props)}>click here</span>.</p>
                {props.emailEdit === true &&
                    <div className={'w-res-50 '}>
                        <TextField
                            type="email"
                            id="customer_email_last"
                            variant="outlined"
                            name="customer_info.customer_email_last"
                            className="form-TextField"
                            onChange={handleChange}
                            onBlur={props.handleChange}
                            onKeyDown={handleKeyDown}
                            value={props.emailValue ? props.emailValue : props.values.customer_info.customer_email_last}
                        />
                        {props.emailEdit === true && lastEmailError === true ?
                            <div className="error-msg">Please provide a valid Email Address</div> : ''
                        }
                    </div>
                }
                <div className="form-content-field">
                    <div className="py-2 row">
                        <div className="py-5 col-md-auto">
                            <Button className="form-button-primary" onClick={pageHandler}>
                                Back 
                            </Button>
                            <Button disabled={props.loader === true} className="form-button-primary home-section-next" type="submit" id="submit" onClick={(props.emailError === true || Object.entries(props.errors).length !== 0 || lastEmailError === true) ? (e) => { props.ValidateFinalError(); } : (e) => { handleClickOpen() }} >
                                {props.loader === false ? 'Finish' : <CircularProgress size={24} color="white" />}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}